import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import type { UseSelectHook } from './useSelect.types';

export const useSelect: UseSelectHook = ({ isVisible, candidate }) => {
  const wasSet = useRef(false);
  const [initialValue, setInitialValue] = useState<string[]>([]);
  const [value, setValue] = useState<string[]>([]);

  useEffect(() => {
    if (isVisible && !wasSet.current) {
      wasSet.current = true;
      setInitialValue(candidate.reasons);
      setValue(candidate.reasons);
    }

    if (!isVisible) {
      wasSet.current = false;
      setInitialValue([]);
      setValue([]);
    }
  }, [isVisible, candidate.reasons]);

  const toggle = useCallback((outcomeKey: string) => {
    setValue((v) => (v.includes(outcomeKey) ? v.filter((o) => o !== outcomeKey) : [...v, outcomeKey]));
  }, []);

  const deselect = useCallback((outcomeKey: string) => {
    setValue((v) => v.filter((o) => o !== outcomeKey));
  }, []);

  const reset = useCallback(() => {
    setValue([]);
  }, []);

  const selected = useMemo(() => value, [value]);

  return {
    initialValue,
    selected,

    toggle,
    deselect,
    reset,
  };
};
